import task from "./task"

const baseUrl = "/api/order/";
export default {
    task

}